<template>
  <div id="app">
    <Header />
    <transition name="fade-custom">
      <router-view></router-view>
    </transition>
    <transition name="fade-down-custom">
      <Waves v-if="waves" />
    </transition>
    <Footer />
  </div>
</template>

<script>
import Waves from "./components/Waves";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "app",
  components: {
    Waves,
    Header,
    Footer
  },
  mounted: function() {
    this.changeBackground();
  },
  updated: function() {
    this.changeBackground();
  },
  methods: {
    changeBackground() {
      document.body.className = "";
      if (this.background === "default") {
        return false;
      } else {
        document.body.classList.add(this.background);
      }
    }
  },
  computed: {
    background() {
      return this.$store.state.background;
    },
    waves() {
      return this.$store.state.waves;
    }
  }
};
</script>

<style lang="scss">
.fade-custom-enter-active {
  transition: all 0.8s ease;
  transition-delay: 0.6s;
}
.fade-custom-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-custom-enter,
.fade-custom-leave-to {
  opacity: 0;
}
/*.fade-down-custom-enter-active {
    transition: all 0.8s ease;
    transition-delay: 0.3s;
  }
  .fade-down-custom-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .fade-down-custom-enter {
    transform: scale(10) translateY(50%);
    opacity: 0;
  }
  .fade-down-custom-leave-to {
    transform: scale(10) translateY(50%);
    opacity: 0;
  }*/
</style>
